import React from "react";

const VARIANTS = {
  info: {
    background: "bg-blue-50",
    border: "border-blue-200",
    iconColor: "text-blue-500",
    textColor: "text-blue-700",
    badgeBg: "bg-blue-100",
    badgeText: "text-blue-800",
  },
  warning: {
    background: "bg-yellow-50",
    border: "border-yellow-200",
    iconColor: "text-yellow-500",
    textColor: "text-yellow-700",
    badgeBg: "bg-yellow-100",
    badgeText: "text-yellow-800",
  },
  success: {
    background: "bg-green-50",
    border: "border-green-200",
    iconColor: "text-green-500",
    textColor: "text-green-700",
    badgeBg: "bg-green-100",
    badgeText: "text-green-800",
  },
  error: {
    background: "bg-red-50",
    border: "border-red-200",
    iconColor: "text-red-500",
    textColor: "text-red-700",
    badgeBg: "bg-red-100",
    badgeText: "text-red-800",
  },
  gray: {
    background: "bg-gray-50",
    border: "border-gray-200",
    iconColor: "text-gray-500",
    textColor: "text-gray-700",
    badgeBg: "bg-gray-100",
    badgeText: "text-gray-800",
  },
  purple: {
    background: "bg-purple-50",
    border: "border-purple-200",
    iconColor: "text-purple-500",
    textColor: "text-purple-700",
    badgeBg: "bg-purple-100",
    badgeText: "text-purple-800",
  },
};

const ICONS = {
  info: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 17h.01M12 12v-4m9 4a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  ),
  warning: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v4m0 4h.01m-7 5h14a2 2 0 001.732-3L13.732 4a2 2 0 00-3.464 0L3.268 18A2 2 0 005 21z"
    />
  ),
  success: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m7 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  ),
  error: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 14l4-4m0 0l-4 4m4-4l-4-4m2 14a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  ),
  question: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.17 9a3.001 3.001 0 015.66 0c0 1.657-1.343 3-3 3v1m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  ),
  notification: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 17h5l-1.405-1.405A2.032 2.032 0 0119 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341A6.002 6.002 0 007 11v3.159c0 .538-.214 1.055-.595 1.436L5 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    />
  ),
};

export function InfoBox({
  variant = "success",
  icon = null,
  title,
  text,
  className = "",
  customIcon = null,
  badge = null, // New badge prop
}) {
  const styles = VARIANTS[variant];

  return (
    <div
      className={`${styles.background} border ${styles.border} rounded-xl p-4 ${
        icon || customIcon ? "flex gap-3" : ""
      } ${className}`}
    >
      {(icon || customIcon) && (
        <div className="flex-shrink-0">
          {customIcon ? (
            <div className={`w-5 h-5 ${styles.iconColor}`}>{customIcon}</div>
          ) : (
            <svg
              className={`w-5 h-5 ${styles.iconColor} mt-0.5`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {ICONS[icon]}
            </svg>
          )}
        </div>
      )}
      <div className={`${styles.textColor} flex-grow`}>
        <div className="flex items-center justify-between">
          <div>
            {title && <h4 className="font-medium mb-1">{title}</h4>}
          </div>
          {badge && (
            <span
              className={`${styles.badgeBg} ${styles.badgeText} text-xs px-2 py-0.5 rounded-full font-medium`}
            >
              {badge}
            </span>
          )}
        </div>
        <p className="text-sm">{text}</p>
      </div>
    </div>
  );
}